import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/allForOrderReportFilter${`?startDate=${string}&endDate=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/allForOrderReportFilter`;

export const URL = (startDate: string, endDate: string): RouteDefinition => `${baseRoute}/allForOrderReportFilter?startDate=${startDate}&endDate=${endDate}`;
